module.exports = __webpack_public_path__ + "static/media/tracker-cam.cc48c74b.png";